import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold font-heading">91在线视频</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-6 max-w-md">
              {footerData.description}
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerData.sections.map((section, idx) => (
            <div key={idx}>
              <h3 className="text-sm font-semibold text-background-50 mb-4">{section.title}</h3>
              <ul className="space-y-2.5">
                {section.links.map((link, linkIdx) => (
                  <li key={linkIdx}>
                    <a
                      href={link.href}
                      onClick={(e) => handleClick(e, link.href)}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 91在线视频 · 91免费在线视频与91免费视频网站平台
            </p>
            <div className="text-xs text-foreground-500">
              <span>合作伙伴 · 友情链接区域</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}